const strings = {
  labels: {
    street: 'Street',
    unit: 'Apt, Unit, Suite, etc.',
    city: 'City',
    state: 'State',
    country: 'Country',
    zip: 'Postal Code',
    address: 'Address',
    addressSearchButton: 'Address Search',
    manualCoordinates: 'Manually Set Lat/Long',
    latitude: 'Latitude',
    longitude: 'Longitude',
  },
  placeholders: {
    address: 'Search for an address',
    street: 'Enter an address',
    unit: 'Unit or Apartment #',
    city: 'Enter a city',
    state: 'Select a state',
    country: 'Select a country',
    zip: 'Enter a postal code',
    latitude: 'Enter latitude coordinate',
    longitude: 'Enter longitude coordinate',
  },
  errors: {
    street: 'Street is required',
    city: 'City is required',
    state: 'State is required',
    country: 'Country is required',
    zipCa: 'Postal code is invalid',
    zipUs: 'Zip code is invalid',
    address: 'Search for an address',
    latitude: 'Latitude should be between -90 and 90',
    longitude: 'Longitude should be between -180 and 180',
  },
} as const;

export default strings;
